export default function Antonyms(props) {
  const antonyms = props.data.antonyms;
  console.log("ant", antonyms);
  function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  if (antonyms.length === 0) {
    return (
      <p>
        <b>Antonyms :</b>None
      </p>
    );
  } else {
    const uniklist = [...new Set(antonyms)];
    return (
      <div className="d-flex">
        <b>Antonyms:</b>
        <ul>
          {uniklist.map((antonyms, index) => (
            <li key={index}>{capitalize(antonyms)}</li>
          ))}
        </ul>
      </div>
    );
  }
}
